// eslint-disable-next-line import/no-unused-modules
module.exports = () => ({
  id: 80047953,
  type: 'private',
})
